import { createGlobalStyle } from 'styled-components'

export const GlobalToastStyle = createGlobalStyle`
  @keyframes antMoveUpIn {
    0% {
      transform: translateY(-100%);
      transform-origin: 0 0;
      opacity: 0;
    }
    100% {
      transform: translateY(0%);
      transform-origin: 0 0;
      opacity: 1;
    }
  }

  .move-up-enter,
  .move-up-appear {
    animation-duration: 0.2s;
    animation-fill-mode: both;
    animation-play-state: paused;
    opacity: 0;
    animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
  }

  .move-up-enter.move-up-enter-active,
  .move-up-appear.move-up-appear-active {
    animation-name: antMoveUpIn;
    animation-play-state: running;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/toast/style.js